import api from './api';

export interface BusinessForm {
  id: number;
  name: string;
  description: string;
  active: boolean;
  created_at: string;
  assigned_at: string;
  assignment_active: boolean;
}

export interface AssignFormRequest {
  form_ids: number[];
}

export interface BusinessFormsResponse {
  data: BusinessForm[];
  total: number;
}

const businessFormsService = {
  /**
   * Obtener formularios asignados a un negocio
   */
  getBusinessForms: async (businessId: number, active: boolean = true) => {
    return api.get<BusinessFormsResponse>(
      `/business/${businessId}/forms?active=${active}`
    );
  },

  /**
   * Asignar formularios (agrega sin eliminar existentes)
   */
  assignForms: async (businessId: number, data: AssignFormRequest) => {
    return api.post(`/business/${businessId}/forms`, data);
  },

  /**
   * Reemplazar todas las asignaciones
   */
  updateForms: async (businessId: number, data: AssignFormRequest) => {
    return api.put(`/business/${businessId}/forms`, data);
  },

  /**
   * Desasignar un formulario específico
   */
  unassignForm: async (businessId: number, formId: number) => {
    return api.delete(`/business/${businessId}/forms/${formId}`);
  }
};

export default businessFormsService;
